import { Howl } from "howler";

const cache = {};

const cdnAudioUrl = `https://${window.config.cdn_address}/${window.config.brand_name_short.toLowerCase()}/audio`;

const DISABLED = true;

export const createHowl = (sound) => {
  // sounds are disabled now. let's not load them
  if (DISABLED) return { play: () => { } };

  const soundUri = `${cdnAudioUrl}/${sound}`;

  if (typeof cache[soundUri] !== "undefined") return cache[soundUri];

  cache[soundUri] = new Howl({
    src: [soundUri],
    html5: true,
    preload: true
  });

  return cache[soundUri]
};